@if (!uiStore.isHandset()) {
<dx-sidenav-container class="h-dvh">
  <dx-sidenav
    #leftSidenav
    [mode]="leftSideNavMode()"
    [position]="'start'"
    [opened]="leftSideNavOpened()"
  >
    <div class="h-full w-full px-3 pb-5 pt-5.5">
      @if (uiStore.theme() === 'light') {
      <img
        src="assets/img/logo-light.png"
        alt="Logo"
        class="h-20 w-auto ml-[-12px]"
      />
      } @if (uiStore.theme() === 'dark') {
      <img
        src="assets/img/logo-dark.png"
        alt="Logo"
        class="h-20 w-auto ml-[-12px]"
      />
      }
      <app-ai-select></app-ai-select>
      <ul class="mt-2 scrollable-menu">
        @for (item of menuItems; track item.id) {
        <!-- Mục cố định của hệ thống: chỉ super admin (theo email) được thấy,
             KHÔNG đi theo AI / role AI / role account → bỏ hẳn *hasRoles. -->
        @if (item.superAdminOnly) { @if (isSuperAdmin()) { @if (item.children) {
        <app-menu-item-multi
          [menuItem]="item"
          [ngClass]="{ 'mt-auto': item.pinBottom }"
        ></app-menu-item-multi>
        } @else {
        <app-menu-item
          [menuItem]="item"
          [ngClass]="{ 'mt-auto': item.pinBottom }"
        ></app-menu-item>
        } } } @else if (item.children) {
        <app-menu-item-multi
          *hasRoles="{
            userRoles: item?.roles ?? [],
            aiRoles: item?.rolesAI ?? []
          }"
          [menuItem]="item"
          [ngClass]="{ 'mt-auto': item.pinBottom }"
        ></app-menu-item-multi>
        } @else {
        <app-menu-item
          *hasRoles="{
            userRoles: item?.roles ?? [],
            aiRoles: item?.rolesAI ?? []
          }"
          [menuItem]="item"
          [ngClass]="{
            'xl:hidden': item.link === APP_ROUTES.PREVIEW,
            'mt-auto': item.pinBottom
          }"
        ></app-menu-item>
        } }
      </ul>
      <div
        class="absolute left-0 bottom-0 bg-base-200 dark:bg-dark-base-200 w-full p-3 flex flex-col border-t border-primary-border dark:border-dark-primary-border"
      >
        <app-user-info-config></app-user-info-config>
      </div>
    </div>
  </dx-sidenav>

  <dx-sidenav
    #rightSidenav
    [mode]="'side'"
    [position]="'end'"
    [opened]="showPreview() && rightSideNavOpened()"
    class="dx-sidenav-preview"
  >
    <div class="h-full overflow-y-auto bg-transparent py-6 pr-8">
      @defer (on viewport) { @if (previewKey() % 2 === 0) {
      <app-preview></app-preview>
      } @if (previewKey() % 2 === 1) {
      <app-preview></app-preview>
      } } @placeholder {
      <div class="h-full w-full bg-gray-200"></div>
      }
    </div>
  </dx-sidenav>

  <dx-sidenav-content
    class="p-4 md:py-6 md:px-10"
    [class.md:pr-4]="showPreview() && rightSideNavOpened()"
  >
    <router-outlet></router-outlet>
  </dx-sidenav-content>
</dx-sidenav-container>
} @else {
<div>
  <main
    class="w-full h-full my-0 mx-auto"
    [ngClass]="{
      '!pb-0': mHideNav(),
      '!pb-18': !mHideNav(),
      'bg-container-background': uiStore.theme() === 'light',
      'bg-dark-container-background': uiStore.theme() === 'dark'
    }"
  >
    <router-outlet></router-outlet>
  </main>
  @if (!mHideNav()) {
  <app-mobile-nav></app-mobile-nav>
  }
</div>
}
